module.exports = __webpack_public_path__ + "img/discount.5a04d932.png";